import { typoM, typoSm } from 'pages/selections/styles';

export const styles = {
  dialog: {
    '& .MuiPaper-root': {
      maxWidth: '750px',
      width: '100%',
      borderRadius: '12px',
      overflow: 'hidden',
    },
  },

  inputsWrapper: {
    display: 'flex',
    gap: '20px',
  },

  total: {
    ...typoSm,
    fontWeight: 500,
    color: '#23252F',
  },

  reminderText: {
    ...typoSm,
    color: '#6E707A',
  },
};
